import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { AppProvider } from "@/context/AppContext";
import Landing from "@/pages/Landing";
import CreatorProfile from "@/pages/CreatorProfile";
import AdminDashboard from "@/pages/AdminDashboard";
import CollectionsPage from "@/pages/CollectionsPage";
import "@/App.css";

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    render() {
        if (this.state.hasError) {
            return (
                <div className="min-h-screen grid place-items-center bg-brand-cream p-8 text-center">
                    <div>
                        <p className="font-display text-3xl font-bold mb-3">Ups, ada yang error.</p>
                        <p className="text-brand-ink/60">Coba refresh halaman ya.</p>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}

function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
        else window.scrollTo(0, 0);
    }, [pathname]);
    return null;
}

function App() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
        window.__lenis = lenis;
        let raf = requestAnimationFrame(function loop(t) {
            lenis.raf(t);
            raf = requestAnimationFrame(loop);
        });
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = undefined;
        };
    }, []);

    return (
        <ErrorBoundary>
            <BrowserRouter>
                <AppProvider>
                    <div className="grain-overlay" aria-hidden="true" />
                    <Toaster richColors position="top-center" />
                    <ScrollToTop />
                    <Routes>
                        <Route path="/" element={<Landing />} />
                        <Route path="/produk/:id" element={<Landing />} />
                        <Route path="/kreator/:name" element={<CreatorProfile />} />
                        <Route path="/koleksi/:id" element={<CollectionsPage />} />
                        <Route path="/acture-admin" element={<AdminDashboard />} />
                        <Route path="/admin" element={<Navigate to="/acture-admin" replace />} />
                        <Route path="*" element={<Landing />} />
                    </Routes>
                </AppProvider>
            </BrowserRouter>
        </ErrorBoundary>
    );
}

export default App;
